/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGrid4x4 = createReactComponent("grid-4x4", "IconGrid4x4", [
  ["path", { d: "M3 6h18", key: "svg-0" }],
  ["path", { d: "M3 12h18", key: "svg-1" }],
  ["path", { d: "M3 18h18", key: "svg-2" }],
  ["path", { d: "M6 3v18", key: "svg-3" }],
  ["path", { d: "M12 3v18", key: "svg-4" }],
  ["path", { d: "M18 3v18", key: "svg-5" }]
]);

export { IconGrid4x4 as default };
//# sourceMappingURL=IconGrid4x4.js.map
